// extracted by mini-css-extract-plugin
export var adjustableWidthBorder = "_4g-5";
export var adjustableWidthBorderHeld = "_4g-6";
export var arrow = "_4g-3";
export var arrowButton = "_4g-4";
export var headerCell = "_4g-0";
export var help = "_4g-2";
export var icon = "_4g-1";
export var noBorder = "_4g-9";
export var nonAdjustableWidthBorder = "_4g-7";
export var nonAdjustableWidthBorderHeld = "_4g-8";